var collapsible_list_component_default = {
  "ltr": "Di419",
  "rtl": "y-PTP",
  "iconContainer": "zvnMI",
  "icon": "Yp8Zo",
  "isExpanded": "JeZAI",
  "listDimensions": "KS9Ao"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
